import config from 'config/default'

const { baseUrl } = config

/**
 * 获取一期讲座信息
 * @param name
 */
export const getClassifyList = async opt => {
    const url = `${baseUrl}/data/classifyList/${opt.theme}.json`
    return await fetch(url)
        .then(resp => resp.json())
        .catch(() => null)
}